import React, {memo, useMemo} from 'react';

import useStyles from './useStyles';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material'
import StylizedMaterialReactTable from "../../StylizedComponents/StylizedMaterialReactTable";
import Box from "@mui/material/Box";

export const ModalAlertsDialog = memo((props) => {

    const {
        onClose,
        title = "",
        open,
        okText = "OK",
        alarmsInfo
    } = props;

    const classes = useStyles()

    const handleOk = () => {
        onClose();
    };

    const columns = useMemo(
        () => [
            {
                accessorKey: 'name', //access nested data with dot notation
                header: 'Объект',
            },
            {
                accessorKey: 'timezone.value', //normal accessorKey
                header: 'Таймзона',
            },
            {
                accessorKey: 'datetime.value',
                header: 'Время',
            },
            {
                accessorKey: 'point.x', //normal accessorKey
                header: 'Широта',
            },
            {
                accessorKey: 'point.y',
                header: 'Долгота',
            },
        ],
        [])

    const rows = useMemo(() => {
        return alarmsInfo
    }, [alarmsInfo])

    const tablesStylesOptions = {
        maxHeightContainer: "35vh",
    }

    const tableOptions = {
        columns,
        data: rows,
        enableStickyHeader: true,
        enableColumnResizing: true,
        enableColumnOrdering: true,
        columnResizeMode: 'onChange',
        enableFullScreenToggle: false,
        positionPagination: 'top',
        onlyPagination: true
    }

    return (
        <Dialog
            open={open}
            className={classes.DialogCustom}
        >

            <Box
                className={classes.boxOfTableModal}
            >

                {title && (
                    <DialogTitle>{title}</DialogTitle>
                )}

                <DialogContent>
                    <StylizedMaterialReactTable
                        tableOptions={tableOptions}
                        tablesStylesOptions={tablesStylesOptions}
                    />
                </DialogContent>

                <DialogActions className={classes.modalActions}>
                    <Button onClick={handleOk} autoFocus>
                        {okText}
                    </Button>
                </DialogActions>
            </Box>

        </Dialog>
    );
})